import { Icon20CloudArrowUpOutline } from '@vkontakte/icons';
import React, { type FC, memo } from 'react';

import styles from './AiPhotoGenerationButtonSave.css';

interface IProps {
    onClick: () => void;
}

export const AiPhotoGenerationButtonSave: FC<IProps> = memo(function AiPhotoGenerationButtonSave(props) {
    const { onClick } = props;

    return (
        <div className={styles.button} onClick={onClick}>
            <Icon20CloudArrowUpOutline data-qa-id="again-icon" />
            Сохранить в Облако
        </div>
    );
});
